import { render, staticRenderFns } from "./WaveComTransactionDetail.vue?vue&type=template&id=d089f176&scoped=true"
import script from "./WaveComTransactionDetail.vue?vue&type=script&lang=js"
export * from "./WaveComTransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d089f176",
  null
  
)

export default component.exports